// extracted by mini-css-extract-plugin
module.exports = {"container":"BuyResultPage-module__container___1MM-S","card":"BuyResultPage-module__card___1jMzu"};